import {
  Box,
  Button,
  ButtonGroup,
  Checkbox,
  CheckboxGroup,
  CloseButton,
  Flex,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from "@chakra-ui/react";
import { leadColumns } from "./leadColumns";
import { crm } from "./crmTheme";

const LeadColumnsModal = ({
  isOpen,
  onClose,
  selectedColumns,
  setSelectedColumns,
}: {
  isOpen: boolean;
  onClose: () => void;
  selectedColumns: string[];
  setSelectedColumns: (cols: string[]) => void;
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered size="md">
      <ModalOverlay bg="blackAlpha.600" backdropFilter="blur(2px)" />
      <ModalContent borderRadius="16px" boxShadow={crm.shadowLg}>
        <ModalHeader borderBottom={`1px solid ${crm.border}`}>
          <Flex w="100%" justifyContent="space-between" alignItems="center">
            <Text fontSize="md" fontWeight="700" color={crm.text}>
              Personalizar colunas
            </Text>
            <CloseButton onClick={onClose} />
          </Flex>
        </ModalHeader>
        <ModalBody>
          <Box
            paddingY="16px"
            minHeight="20vh"
            maxHeight="50vh"
            overflowY="scroll"
            paddingLeft="4px"
          >
            <Checkbox
              isChecked={
                selectedColumns.length > 0 &&
                leadColumns.every((c) => selectedColumns.includes(c.label))
              }
              onChange={(e) => {
                if (e.target.checked) {
                  setSelectedColumns(leadColumns.map((c) => c.label));
                } else {
                  setSelectedColumns([]);
                }
              }}
              mb="24px"
              colorScheme="blue"
            >
              <Text fontSize="sm" fontWeight="600" color={crm.text}>
                Selecionar todas
              </Text>
            </Checkbox>
            <CheckboxGroup
              value={selectedColumns}
              onChange={(vals) => setSelectedColumns(vals.map((v) => v.toString()))}
            >
              <Flex flexDirection="column" gap="10px">
                {leadColumns.map((c) => (
                  <Checkbox key={c.index} value={c.label} colorScheme="blue">
                    <Text fontSize="sm" color={crm.text}>{c.label}</Text>
                  </Checkbox>
                ))}
              </Flex>
            </CheckboxGroup>
          </Box>
        </ModalBody>
        <ModalFooter borderTop={`1px solid ${crm.border}`}>
          <ButtonGroup>
            <Button
              bg={crm.brand}
              color="white"
              _hover={{ bg: crm.brandDark }}
              borderRadius="10px"
              onClick={onClose}
            >
              Salvar
            </Button>
          </ButtonGroup>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default LeadColumnsModal;
